jQuery(function() {

    moment.locale(app_locale ?? 'es');

    var DateRangePicker = {
        el_rp: null,
        el_checkin: null,
        el_checkout: null,
        el_nights: null,
        input: null,
        drp: null,
        moment_format: 'ddd, D MMM',
        template_booking_dates:
            '<div class="drp-booking">' +
            '<div class="drp-checkin"></div>' +
            '<div class="drp-checkout"></div>' +
            '<div class="drp-nights"></div>' +
            '</div>',
        clearSameDate: function () {
            var $that = DateRangePicker,
                drp = $that.drp;
            // console.log(drp.startDate.format('YYYYMMDD'), drp.endDate.format('YYYYMMDD'));
            if (drp.startDate !== null && drp.endDate !== null && drp.startDate.format('YYYYMMDD') === drp.endDate.format('YYYYMMDD')) {
                $that.el_checkin.html('');
                $that.el_checkout.html('');
                $that.el_nights.html('');
                return true;
            }
            return false;
        },
        updateBookingInfo: function () {
            var $that = DateRangePicker,
                drp = $that.drp;
            if ($that.clearSameDate()) {
                return;
            }
            if (drp.startDate !== null) {
                $that.change_in(drp.startDate.format($that.moment_format));
            }
            if (drp.endDate !== null) {
                $that.change_out(drp.endDate.format($that.moment_format));
                $that.change_nights(drp.startDate, drp.endDate);
            } else {
                $that.el_checkout.html('');
                $that.el_nights.html('');
            }

        },
        mouseLeave: function () {
            this.el_rp.on("mouseleave", "table td.available", function (ev) {
                DateRangePicker.updateBookingInfo();
            });
        },
        mouseEnter: function () {
            this.el_rp.on("mouseenter", "table td.available", function(ev) {
                var $that = DateRangePicker,
                    drp = $that.drp;

                // if ($that.clearSameDate()) {
                //     return;
                // }

                var title = $(ev.target).attr('data-title');
                var row = title.substr(1, 1);
                var col = title.substr(3, 1);
                var cal = $(ev.target).parents('.drp-calendar');
                var isLeft = cal.hasClass('left');
                var date = isLeft ? drp.leftCalendar.calendar[row][col] : drp.rightCalendar.calendar[row][col];

                if (drp.startDate !== null && drp.endDate !== null) {
                    $that.change_in(date.format($that.moment_format));
                    $that.el_checkout.html('');
                    $that.el_nights.html('');
                } else {
                    if (drp.startDate !== null && drp.endDate === null) {
                        if (drp.startDate > date) {
                            $that.change_in(date.format($that.moment_format));
                            $that.el_checkout.html('');
                            $that.el_nights.html('');
                        } else {
                            $that.change_in(drp.startDate.format($that.moment_format));
                            $that.change_out(date.format($that.moment_format));
                            $that.change_nights(drp.startDate, date);
                        }
                    } // else ???
                    if (drp.endDate !== null) {
                        $that.change_out(drp.endDate.format($that.moment_format));
                        $that.change_nights(drp.startDate, drp.endDate);
                    }
                }
            });
        },
        sep_drp: '<span class="sep-drp">-</span>',
        change_in: function ($value) {
            DateRangePicker.el_checkin.html('<span>ENTRADA:</span> ' + $value);
        },
        change_out: function ($value) {
            var $that = DateRangePicker;
            $that.el_checkout.html($that.sep_drp + '<span>SALIDA:</span> ' + $value);
        },
        change_nights: function ($in, $out) {
            var $that = DateRangePicker,
                nights = $out.diff($in, 'days');
            if (nights <= 0) {
                $that.el_nights.html('');
                return;
            }
            var text_nights = 'noches';
            if (nights === 1) {
                text_nights = 'noche';
            }
            $that.el_nights.html($that.sep_drp + nights +' '+ '<span>'+text_nights+'</span>');
        },
        updateOnShow: function() {
            this.input.on('show.daterangepicker', function() {
                DateRangePicker.updateBookingInfo();
            });
            /*this.el_rp.on('mouseenter.daterangepicker', function(a,b) {
                console.log(a,b);
            });*/
        },
        updateInput: function() {
            var $that = DateRangePicker;
            this.input.on('apply.daterangepicker', function(ev, picker) {
                $(this).val(picker.startDate.format($that.moment_format) + ' - ' + picker.endDate.format($that.moment_format));
            });
        },
        updateCheckInOut: function (start, end) {
            if (this.clearSameDate()) {
                return;
            }
            $('#checkin').attr('value', start.format('DD/MM/YYYY'));
            $('#checkout').attr('value', end.format('DD/MM/YYYY'));
        },
        init: function ($input) {
            this.input = $($input);

            if (this.input.length) {
                var from_date = moment();
                // var to_date = from_date.clone().add(1, 'day');

                var toUpperCase = function ($element) {
                    return $element.toUpperCase();
                };

                this.input.daterangepicker({
                    minDate: from_date,
                    // startDate: from_date,
                    // endDate: to_date,
                    autoApply: true,
                    autoUpdateInput: false,
                    locale: {
                        format: this.moment_format,
                        daysOfWeek: moment.weekdaysMin().map(toUpperCase),
                        monthNames: moment.months().map(toUpperCase),
                    }
                }, function(start, end, label) {
                    DateRangePicker.updateCheckInOut(start, end);
                });

                this.el_rp = $('.daterangepicker');
                $(this.template_booking_dates).appendTo(this.el_rp.find('.drp-buttons'));

                this.el_checkin = this.el_rp.find('.drp-checkin');
                this.el_checkout = this.el_rp.find('.drp-checkout');
                this.el_nights = this.el_rp.find('.drp-nights');

                this.drp = this.input.data('daterangepicker')

                this.mouseEnter();
                this.mouseLeave();
                this.updateInput();
                this.updateOnShow();

                this.updateCheckInOut(this.drp.startDate, this.drp.endDate);
            }
        }
    };

    DateRangePicker.init('#checkin-checkout');

});